import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme => ({
  translateIcon: {
    fontSize: '18px',
    cursor: 'pointer',
    '&:hover': {
      color: '#626DF9',
    },
  },
  translatedBtn: {
    display: 'flex',
    gap: '10px',
    color: 'white',
    marginTop: '10px',
    marginBottom: '10px',
    padding: '8px 16px',
  },
}));

export default useStyles;
